export default __webpack_public_path__ + "static/char-v-08-a6901528d6184133a2ffc6f660549257.webp";